import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";

const STORAGE_KEY = "hay-cookie-consent";

/** Компактная плашка согласия с куками. Аналитика работает независимо от выбора. */
export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!window.localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      /* приватный режим — просто не показываем повторно */
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* noop */
    }
    setVisible(false);
  };

  return (
    <div className="fixed inset-x-4 bottom-4 z-[90] lg:inset-x-auto lg:right-6 lg:bottom-6 lg:max-w-[360px]">
      <div className="flex items-center gap-4 rounded-[14px] border border-border bg-background p-4 shadow-[0_12px_40px_rgba(0,0,0,0.12)]">
        <p className="body-12 text-muted-foreground">
          Мы используем куки для аналитики и улучшения сайта. Подробнее —{" "}
          <Link to="/privacy" className="text-foreground underline underline-offset-2">
            в политике
          </Link>
          .
        </p>
        <button
          type="button"
          onClick={accept}
          className="shrink-0 rounded-full bg-foreground px-4 py-2 text-[13px] font-semibold text-background transition-opacity hover:opacity-80"
        >
          ОК
        </button>
      </div>
    </div>
  );
}
